var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-row",
    [
      _c(
        "b-col",
        { staticClass: "d-flex justify-content-end", attrs: { md: "2" } },
        [
          _c(
            "b-button",
            {
              attrs: { variant: "primary" },
              on: { click: _vm.redirectToWebsite },
            },
            [_vm._v(" Visit Website ")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }